import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { LoadingService } from 'src/app/services/loading.service';
import { LdProject } from '../../models/feature-flag-models';

@Component({
  selector: 'app-project-selector',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatSelectModule
  ],
  template: `
    <mat-form-field>
      <mat-label>Select Project</mat-label>
      <mat-select
        [disabled]="disabled || (loadingService.loading$ | async)"
        (selectionChange)="onProjectSelected($event.value)"
        >
        @for (project of projects; track project) {
          <mat-option [value]="project">
            {{ project.name }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    `,
  styles: [
    `
      mat-form-field {
        width: 100%;
        max-width: 500px;
      }
    `
  ]
})
export class ProjectSelectorComponent {
  @Input() projects: LdProject[] | null = null;
  @Input() disabled = true;
  @Output() projectSelected = new EventEmitter<LdProject>();

  constructor(public loadingService: LoadingService) {}

  onProjectSelected(project: LdProject): void {
    this.projectSelected.emit(project);
  }
}
